import functionalAssessment from '../../assets/images/Services/functional-assessment.jpg';
import otTherapy from '../../assets/images/Services/ot-therapy.jpg';
import sensoryInteroception from '../../assets/images/Services/sensory-interoception.jpg';
import homeReports from '../../assets/images/Services/home-reports.jpg';
import mentalHealth from '../../assets/images/Services/mental-health.jpg';
import assistiveTechnology from '../../assets/images/Services/assistive-technology.jpg';
import accessReports from '../../assets/images/Services/access-reports.jpg';
import natureTherapy from '../../assets/images/Services/nature-therapy.jpg';


import logoImage from '../../assets/images/Logo500px.png';


const ServiceImages = {
  functionalAssessment,
  otTherapy,
  sensoryInteroception,
  homeReports,
  mentalHealth,
  assistiveTechnology,
  accessReports,
  natureTherapy
};

export default ServiceImages;
